module.exports = __webpack_public_path__ + "static/media/mobile-hero.53b32bdf.png";